module.exports = __webpack_public_path__ + "img/galeria_salas_de_aula (6).ab3a14ee.jpeg";